import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  errorContainer: {
    backgroundColor: '#d32f2f',
    color: '#fff',
    padding: '6px 16px',
    borderRadius: '4px',
    boxShadow:
      '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)',
    display: 'flex',
    alignItems: 'center',
    maxWidth: '78vw',
    wordBreak: 'break-all',
  },
  icon: {
    marginRight: '12px',
    flexShrink: 0,
    width: '16px',
    height: '16px',
    cursor: 'pointer',
  },
  message: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
    flex: 1,
  },
  link: {
    color: 'inherit',
    textDecoration: 'underline',
  },
}));

export default useStyles;
